import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, MenuItem } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import AppButton from 'src/components/appComponents/AppButton';
import FormBlock from 'src/components/appComponents/FormBlock';
import FormProvider, { RHFRadioGroup, RHFSelect, RHFTextField } from 'src/components/hook-form';
import { useCreateInstallReferrerMutation } from 'src/graphql';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { AddInstallReferrerSchema } from 'src/schema';
import { ICreateInstallReferrerDto } from 'src/types/marketing';

const PHONE_TYPE = [
  { id: 'GOOGLE', name: { en: 'Android' } },
  { id: 'APPLE', name: { en: 'iPhone' } },
];

export default function AddMarketingForm() {
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();

  const { mutate: createInstallReferrer, isLoading: isLoadingCreateInstallReferrer } =
    useCreateInstallReferrerMutation({
      onSuccess: () => {
        enqueueSnackbar({ variant: 'success', message: 'Completed Successfully' });
        router.push(paths.dashboard.marketing.root);
      },
    });

  const methods = useForm<ICreateInstallReferrerDto>({
    resolver: yupResolver(AddInstallReferrerSchema),
  });

  const onSubmit = (data: ICreateInstallReferrerDto) => {
    createInstallReferrer({
      input: { ...data, utmMedium: data.type == 'GOOGLE' ? data.utmMedium : data.utmCampaign },
    });
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
      <Grid container rowSpacing={3} alignItems="center">
        <FormBlock
          title="Phone Type*"
          inputField={<RHFRadioGroup row spacing={3} name="type" options={PHONE_TYPE ?? []} />}
        />
        {methods.watch()?.type && (
          <>
            <FormBlock
              title="Utm Source*"
              inputField={
                <RHFSelect name="utmSource" label="Choose Utm Source">
                  <MenuItem value="Facebook">Facebook</MenuItem>
                  <MenuItem value="x">x</MenuItem>
                  <MenuItem value="TikTok">TikTok</MenuItem>
                  <MenuItem value="snapchat">snapchat</MenuItem>
                  <MenuItem value="TikTok">TikTok</MenuItem>
                  <MenuItem value="google ads">google ads</MenuItem>
                </RHFSelect>
              }
            />
            <FormBlock
              title="Utm Campaign*"
              inputField={<RHFTextField name="utmCampaign" label="Enter Utm Campaign" />}
            />
            {methods.watch()?.type !== 'APPLE' && (
              <FormBlock
                title="Utm Medium*"
                inputField={<RHFTextField name="utmMedium" label="Enter Utm Medium" />}
              />
            )}
            <Grid item container justifyContent="flex-end">
              <AppButton
                label="Add"
                type="submit"
                color="primary"
                isLoading={isLoadingCreateInstallReferrer}
              />
            </Grid>
          </>
        )}
      </Grid>
    </FormProvider>
  );
}
